import get from 'get-object-path';

export const squads = {
    state: {
        selectedSquad: {
            squad_users: []
        },
        selectedFile: null
    },

    getters: {
        selectedSquad(state) {
            return state.selectedSquad;
        },

        selectedFile(state) {
            return state.selectedFile;
        }
    },

    mutations: {
        selectSquad(state, data) {
            state.selectedSquad = data;
        },

        selectFile(state, file) {
            state.selectedFile = file;
        },

        addWallPost(state, wallPost) {
            const fileComments = get(state.selectedFile, 'wall_post_file_comments.data');
            if (fileComments) {
                const index = fileComments.findIndex(post => post.id === wallPost.id);
                if (index === -1) {
                    fileComments.push(wallPost);
                }
            }
        },

        removeWallPost(state, postId) {
            const fileComments = get(state.selectedFile, 'wall_post_file_comments.data') || [];
            const index = fileComments.findIndex(comment => comment.id === postId);
            if (index !== -1) {
                fileComments.splice(index, 1);
            }
        }
    }
};

export default squads;
